//
//
//
//
//
//
//
//
//
//
//
//
//
import pop from '@/mixin/pop';
import Storage from '@tencent/vft-common/Storage';
var SAVE_KEY = 'ysf_lxky_live_show_time';
export default {
  mixins: [pop],
  created: function created() {
    var now = this.now;
    var time = Storage.get(SAVE_KEY);

    if (time && +time + 10 * 60 * 1000 > now) {
      return;
    }

    if (this.isLive) {
      this.eventBus.$emit('showLivePop');
      Storage.set(SAVE_KEY, Date.now());
    }
  }
};